import styled from 'styled-components'
import { Form } from 'semantic-ui-react'

export default styled(Form.Group)`
	&&&& {
		margin: 0;
	}
`
